import React, {useState,useEffect} from 'react'
import parse from 'html-react-parser';
import { Link, useLocation } from 'react-router-dom';
import { useNavigation } from '../Contexts/NavigationContext'
import Skeleton from "react-loading-skeleton";

const urlReplace = (url) => {
	return url.replace('https://blackoctopus-sound.infinitelabyrinth.com','').replace(window.location.origin, '');
}

const BannerMenu = ({items}) => { 
	return (
		<ul className="banner-nav">
			{items && items.map(item=>{
				return <li key={item.id}><Link to={urlReplace(item.url)}>{parse(item.title)}</Link></li>
			})}
			{!items && <li>&nbsp;</li>}
		</ul>
	)
}

export default function Banner ({backgroundImage,title,description=null,path=[]}) { 
	const nav = useNavigation();
	const location = useLocation();
	const [navItems,setNavItems] = useState(null);
	let breadCrumbsTitle = title;

	useEffect(()=> { 
		nav['menu-1'].menu.items.map(el => { 
			if(el.object_slug === 'gold') setNavItems(el.children); 
			return null;
		}); 
	},[nav])
	
	if(title === '404') {
		title = '404 <span style="font-size:50%;">Error</span>';
		description = '<h2>Oops! That page can’t be found.</h2>';
		breadCrumbsTitle = 'ERROR';
	}

	return (
		<React.Fragment>
		{title && 
		<React.Fragment>
			<header className="entry-header" style={{backgroundImage: "url("+backgroundImage+")"}}>
				<div className="breadcrumbs">
					<span className="crumb"><a href="/">Home</a></span> &nbsp;&nbsp; 
					{(location.pathname !== "/gold" && location.pathname !== "/gold/") && <React.Fragment><span className="crumb"><Link to={{pathname:"/gold"}}>Gold</Link></span> &nbsp;&nbsp; </React.Fragment> }
					{path.map((item,inx) => ( <React.Fragment key={inx}><span className="crumb"><Link to={{pathname:item.path}}>{item.title}</Link></span> &nbsp;&nbsp; </React.Fragment> ))}
					<span className="crumb breadcrumb-current">{(title && parse(breadCrumbsTitle))}</span>
				</div>
				<h1 className={"entry-title "+(description ? "with-description" : "")}>{(title && parse(title))}</h1>
				{description && <div className="entry-description">{parse(description)}</div>}
			</header>
			<BannerMenu items={(navItems ? navItems : null)} />
		</React.Fragment>
		}
		{!title && 
			<React.Fragment>
				<header className="entry-header">
					<div className="breadcrumbs"><Skeleton width={200} /></div>
					<h1 className="entry-title"><Skeleton width={400}  /></h1>
				</header>
				<BannerMenu items={(navItems ? navItems : null)} />
			</React.Fragment>
		}
		</React.Fragment>
	)
}